import { getAxio } from '../api';

const path = "zone/"

export function getAllZone(){
    return getAxio().get(path + 'all').then((res:any) => {
        return res.data
     } ) 
}
